import { useStripeApi } from "../api/StripeApiClient";
import { StripeFrontendService } from "../services/StripeFrontendService";

export const useStripeService = (): StripeFrontendService =>
  new StripeFrontendService(useStripeApi());
